import * as React from "react";

export const MegamenuOverlay = ({ settings, type = 'darken'}) => {

    const { blocks } = settings;
    const overlaySettings = blocks.find((block) => block.type === "overlay");

    const overlayEffectValue = overlaySettings?.settings.effect_size;
    const effectClass = overlaySettings?.settings.mask === "darken" ? `bg-black` : ``;
    const effectStyle = overlaySettings?.settings.mask === "darken"
        ? { opacity: overlayEffectValue / 100 }
        : overlayEffectValue > 0
            ? { backdropFilter: `blur(${overlayEffectValue}px)` }
            : {}; // No style applied if overlayEffectValue is 0

    return (
        <div className={`megamenu-overlay type-${overlaySettings?.settings.mask} ${effectClass}`} style={effectStyle}></div>
    );
};
